var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Isolation_Mode",
    clipPath: "url(#clip0_1197_729)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.55502 1.77986C3.55502 2.75878 2.93207 3.55972 1.77516 3.55972C0.707244 3.55972 -0.00469971 2.75878 -0.00469971 1.86885C-1.58665e-05 0.88993 0.711928 0 1.77984 0C2.84776 0 3.5597 0.800937 3.5597 1.77986H3.55502Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M3.55504 4.44507H0V16.0001H3.55504V4.44507Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M12.089 4.62309C10.2201 4.62309 9.15692 5.69101 8.71195 6.40295H8.62296L8.44497 4.89007H5.24591C5.24591 5.86899 5.3349 7.02122 5.3349 8.35611V16.0001H8.88994V9.69101C8.88994 9.33504 8.88994 9.06806 8.97893 8.80108C9.24591 8.17813 9.69088 7.37719 10.6698 7.37719C11.9157 7.37719 12.4497 8.44511 12.4497 9.86431V15.9955H16.0047V9.41935C16.0047 6.13129 14.3138 4.61841 12.0937 4.61841L12.089 4.62309Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1197_729"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.a37a61b9b737775c50b630897cd1c111.svg";
export { ForwardRef as ReactComponent };